<template>
    <cadastro-simples-form
        endpoint="almox-motivo-recusa"
        rota-base="/admin/almox-motivo-recusa"
        titulo-singular="Motivo">
    </cadastro-simples-form>
</template>
<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
